export default __webpack_public_path__ + "static/media/team-01.fb987960.png";